module.exports = __webpack_public_path__ + "media/images/icons/side_menu_gruppi_attivo-82333be5350864a8cfc2bfe2a5563c66.svg";